import { Box, Typography, useTheme } from '@mui/joy';
import { Trans } from 'react-i18next';

import { IBomPart } from 'bom/types';
import { PartNumberHelper } from 'parts/helpers';
interface IProps {
  selectedBomParts: IBomPart[];
}

export const SubtitleSelectedBomParts = ({ selectedBomParts }: IProps) => {
  const theme = useTheme();

  const isSingleSelection = selectedBomParts?.length === 1;
  const selectedBomPart = isSingleSelection && selectedBomParts[0];

  const wrapper = <Box sx={{ display: 'flex', gap: 0.5 }} />;
  const valueWrapper = <Typography fontWeight={800} sx={{ color: theme.palette.neutral[800] }} />;

  if (selectedBomParts.length > 1 || selectedBomPart?.partArr?.number) {
    return (
      <Trans
        i18nKey="subtitleForSelectedPart"
        values={{
          partNumber: PartNumberHelper.toLabel(selectedBomPart?.partArr?.number),
          count: selectedBomParts?.length,
        }}
        components={{
          wrapper,
          valueWrapper,
        }}
      />
    );
  }

  return (
    <Trans
      i18nKey="subtitleForSelectedPartComponent"
      values={{
        componentName: selectedBomPart?.componentName,
      }}
      components={{
        wrapper,
        valueWrapper,
      }}
    />
  );
};
